// src/components/PermisoWrapper.js
import React from 'react';
import AccesoDenegado from './AccesoDenegado';

export default function PermisoWrapper({ permisoId, children }) {
  let permisosRaw = [];
  try {
    permisosRaw = JSON.parse(sessionStorage.getItem('Permisos') || '[]');
  } catch {
    permisosRaw = [];
  }

  const permisos = Array.isArray(permisosRaw)
    ? permisosRaw.map((permiso) => Number(permiso)).filter((permiso) => !Number.isNaN(permiso))
    : [];
  const tienePermiso = permisos.includes(Number(permisoId));

  return (
    <>
      {tienePermiso ? children : <AccesoDenegado inline />}
    </>
  );
}
